"use client";

import { forwardRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import * as S from "./styles";
import LabelInput from "@/components/label";

interface PhoneInputProps {
  label?: string;
  name?: string;
  value?: string;
  onChange?: (...event: any[]) => void;
  onBlur?: (...event: any[]) => void;
  disabled?: boolean;
  validation?: {
    message: string;
    type: string;
  };
}

const PhoneInputField = forwardRef<HTMLInputElement, PhoneInputProps>(
  (
    { label, name, value = "", onChange, onBlur, disabled, validation },
    _ref,
  ) => {
    const [country, setCountry] = useState("br");

    // Definindo máscaras específicas por país
    const masks = {
      br: "(..) .....-....",
      default: "... ... ...",
      pt: "... ... ...",
    };

    return (
      <>
        {label && <LabelInput labelInput={label} />}
        <S.BoxPhoneInput style={{ maxWidth: 300 }}>
          <S.InputPhone
            country={country}
            value={value}
            onBlur={onBlur}
            onChange={(value, data) => {
              if (data && typeof data === "object" && "countryCode" in data) {
                const countryCode = (data as { countryCode?: string })
                  .countryCode;
                if (countryCode && countryCode !== country) {
                  setCountry(countryCode);
                }
              }

              if (onChange) {
                const fakeEvent = {
                  target: {
                    name,
                    value,
                  },
                } as unknown as React.ChangeEvent<HTMLInputElement>;
                onChange(fakeEvent);
              }
            }}
            inputProps={{ name, disabled }}
            inputStyle={{
              width: "100%",
              padding: "10px",
              fontSize: "16px",
            }}
            buttonStyle={{ border: "none" }}
            enableSearch
            masks={masks}
          />
        </S.BoxPhoneInput>

        {validation?.type === "error" && (
          <S.ErrorMessage>{validation.message}</S.ErrorMessage>
        )}
      </>
    );
  },
);

PhoneInputField.displayName = "PhoneInputField";

export default PhoneInputField;
